import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../../services/AuthService";
import "./Register.css";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const bgStyle = {
    backgroundImage: "url('/geometric-bg.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: "#ffffff",
  };

  const handleRegister = async () => {
    try {
      await register(name, email, password, "register");
      setMessage("Kayıt başarılı! Giriş sayfasına yönlendiriliyorsunuz...");
      setTimeout(() => navigate("/"), 2000);
    } catch {
      setMessage("Kayıt işlemi başarısız");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="video-section">
        <video src="/login_video.mp4" autoPlay loop muted playsInline />
        <img src="/buglog-white.svg" alt="Buglog" className="corner-logo" />
      </div>

      <div className="form-section" style={bgStyle}>
        <div className="register-container">
          <h2>
            <img src="/buglog.svg" alt="Buglog Logo" height={50} />
          </h2>

          {message && <p className="message">{message}</p>}

          <div className="input-group">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="İsim Soyisim"
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="E-posta Adresi"
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Şifre"
            />
          </div>
          <button onClick={handleRegister} className="primary-btn">
            Kayıt Ol
          </button>
        </div>
      </div>
    </div>
  );
};

export default Register;
